import { createEntityCollectionStore } from '@core/ngrx-legacy';
import type {
  ConversationStarters,
  ConversationStartersContext,
} from '@core/tellent-assistant-types';

type ConversationStartersEntry = ConversationStarters & { id: string };

const idSelector = (entry: ConversationStartersEntry) => entry.id;

const { selectors, reducer, actions, namespace } =
  createEntityCollectionStore<ConversationStartersEntry>()('ConversationStarters', {
    idSelector,
    customActions: adapter => ({
      fetchOne: (state, payload: { id: string; ctx: ConversationStartersContext }) =>
        adapter.markAsPending(state, { scope: null, entities: [payload.id] }),
    }),
  });

export {
  selectors as ConversationStartersSelectors,
  reducer as ConversationStartersReducer,
  actions as ConversationStartersActions,
  namespace as ConversationStartersNamespace,
};
